import React from "react";
import { Button } from "../Button";
import { ServiceCard } from "./ServiceCard";
import { ContactButton, Container, ServiceContainer } from "./style";

export const Servicos = () => {
  const services = [
    {
      number: 1,
      title: "Criação Web e Digital",
      description:
        "Criação de sites que se comunicam com seu público alvo gerando resultados para seu negócio. Sites responsivos para diversas plataformas e dispositivos.",
      services:
        "Posso te ajudar a criar: Landing Pages, Sites, Hotsites, e-Commerce",
    },
    {
      number: 2,
      title: "Desenvolvimento: Sites e Hotsites",
      description:
        "Programação de layouts utilizando como por exemplo ReactJS e API. De portais a sites instituicionais, hotsites de eventos e promoções, até lojas virtuais completas.",
      services:
        "Posso te ajudar a desenvolver: Sites, hotsites, gerenciadores de conteudo e lojas virtuais.",
    },
    {
      number: 3,
      title: "Criação Web e Digital",
      description:
        "Criação de sites que se comunicam com seu público alvo gerando resultados para seu negócio. Sites responsivos para diversas plataformas e dispositivos",
      services:
        "Posso te ajudar a criar: Landing Pages, Sites, Hotsites, e-Commerce",
    },
  ];

  return (
    <Container>
      <h2 className="title">Serviços</h2>
      <ServiceContainer>
        {services.map((service) => (
          <ServiceCard service={service} />
        ))}
      </ServiceContainer>
      <Button>Entre em contato</Button>
    </Container>
  );
};
